import React from 'react';


class TitleText extends React.Component {
    render(){
        return(
            <div className="wordingCarousel" data-aos={"fade-up"} style={{width: "auto"}}>
                <div className="inner">
                    Vivid software products <br/>
                    for your business
                </div>
            </div>
        );
    }

}


export default TitleText;